export default function Success({ message }) {
  return (
    <div style={{ color: "#1168db", marginLeft: "450px", marginTop: "20px" }}>
      {message}
    </div>
  );
}
